import React, { useEffect, useState, useRef } from "react";
import Axios from 'axios';
import '../../App.css';
import "../pages/login.css"
import { redirect, useNavigate } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
 
function Login(props) {
 
 const regPass = useRef(null);
 const regEmail = useRef(null);
 const signPassword = useRef(null);
 const signEmail = useRef(null);
 const [usernameReg, setUsernameReg] = useState("");
 const [passwordReg, setPasswordReg] = useState ("");
 
 const [username, setUsername] = useState("");
 const [password, setPassword] = useState ("");
 let navigate = useNavigate();
 //const [loginStatus, setLoginStatus] = useState("");
 const isEmail = (email) =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
 const [errors, setErrors] = useState({});
 const [token, setToken] = useState(null);
 //const [role, setRole] = useState("");
 
 //Axios.defaults.withCredentials = true;

 //const [password, setPassword] = useState("");
  const [strength, setStrength] = useState("");

  const checkPasswordStrength = (passwordReg) => {
    const criteria = [
      { regex: /.{8,}/, message: "At least 8 characters" },
      { regex: /[A-Z]/, message: "At least one uppercase letter" },
      { regex: /[a-z]/, message: "At least one lowercase letter" },
      { regex: /\d/, message: "At least one number" },
      { regex: /[@$!%*?&]/, message: "At least one special character" },
    ];

    const passedCriteria = criteria.filter((criterion) =>
      criterion.regex.test(passwordReg)
    );

    if (passwordReg.length === 0) {
      return "Enter a password";
    } else if (passedCriteria.length <= 2) {
      return "Weak";
    } else if (passedCriteria.length <= 4) {
      return "Moderate";
    } else {
      return "Strong";
    }
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPasswordReg(newPassword);
    setStrength(checkPasswordStrength(newPassword));
    console.log(passwordReg);
  };

 const register = (e) => {
    e.preventDefault();
    const errors = {};
 
    if (!isEmail(usernameReg)) {
      regEmail.current.focus();
      errors.email = "Enter a valid email.";
      setErrors(errors);
      return;
    }
 
    if (!Object.keys(errors).length) {
      //alert(JSON.stringify(usernameReg, null, 2));
    }

    console.log(usernameReg + ' ' + passwordReg);
    Axios.post("https://mygamename.com/php/signup.php", {
      username: usernameReg,
      password: passwordReg,
    }).then((response) => {
        console.log(response);
        if(response.message === "EAU"){
          errors.email = "Email already used.";
          setErrors(errors);
          signUpClick();
          return;
        }

          Axios.post("https://mygamename.com/php/login.php", {
            username: usernameReg,
            password: passwordReg,
         }).then((response) => {
            if (response.data.message) {
              props.setLoginStatus(response.data.message);
            } else {
              console.log(response);
              props.setLoginStatus(response.data[0].email);
              setUsername('');
              setPassword('');
              props.setLoginStatus(true);
              navigate('/create');
            }
         });
        
        //return;
      
    });
 };

 const signUpClick = () => {
  regEmail.current.focus();
  const element = document.getElementById('login-container');
  element.classList.add("right-panel-active");
 }

 const signInClick = () => {
  signEmail.current.focus();
  const element = document.getElementById('login-container');
  element.classList.remove("right-panel-active");
 }
 
 const login = (e) => {
    
    e.preventDefault();
      
    const errors = {};
 
    if (!isEmail(username)) {
      errors.email = "Email";
    }
 
    setErrors(errors);
 
    if (!Object.keys(errors).length) {
      //alert(JSON.stringify(username, null, 2));
    }
 Axios.post("https://mygamename.com/php/login.php", {
    username: username,
    password: password,
 }).then((response) => {
    if (response.data.message) {
      props.setLoginStatus(response.data.message);
    } else {
      props.setLoginStatus(true);
      if (response.data.token) {
        setToken(response.data.token);
      }
      props.setUEmail(response.data[0].email);
      setUsername('');
      setPassword('');
      console.log(response);
      props.setLoginStatus(true);
      navigate('/create');
    }
 });
 };
 useEffect(() => {
  const fetchProtected = async () => {
    try {
      const response = await Axios.get('https://mygamename.com/php/protected.php', { withCredentials: true });
      console.log(response);
      if (response.data.status === 'success') {
        //setEmail(response.data.email);
        props.setUEmail(response.data.email);
      } else {
        //window.location.href = '/login';
      }
    } catch (error) {
      console.error(error);
      //window.location.href = '/login';
    }
  };

  fetchProtected();
}, []);

 
 return (
    <div className="login-container" id="login-container">
      <div className="form-container sign-up-container">
        <form action="#">
          <h1 className="mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-800 md:text-5xl lg:text-6xl dark:text-white">Create Account</h1>
          {/* <div class="social-container">
            <a href="http://localhost/" class="social"><i class="fab fa-facebook-f"></i></a>
            <a href="http://localhost/" class="social"><i class="fab fa-google-plus-g"></i></a>
            <a href="http://localhost/" class="social"><i class="fab fa-linkedin-in"></i></a>
          </div>
          <span>or use your email for registration</span> */}
          <input
                type="text"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[2em] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                placeholder="Email"
                value={usernameReg}
                ref={regEmail}
                onChange={(e) => {
                    setUsernameReg(e.target.value);
                }}
              />
          <input 
                type="text"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[2em] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                placeholder='Password'
                value={passwordReg}
                ref={regPass}
                onChange={handlePasswordChange}
          />
          <p className={`font-semibold ${strength === "Strong" ? "text-green-600" : strength === "Moderate" ? "text-yellow-600" : "text-red-600"}`}>
        {strength}
      </p>
          {Object.entries(errors).map(([key, error]) => (
        <span
          key={`${key}: ${error}`}
          style={{
            fontWeight: "bold",
            color: "red"
          }}
        >
          {error}
        </span>
      ))}
          <button onClick={register}>Sign Up</button>
        </form>
      </div>
      <div className="form-container sign-in-container">
        <form action="#">
          <h1 className="mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl dark:text-white">Sign in</h1>
          <div className=""></div>
          <input
                type="text"
                placeholder="Email"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[2em] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                value={username}
                ref={signEmail}
                onChange = { (e) => {
                  setUsername (e.target.value);
                }}
                />
          <input
                type="password"
                placeholder="Password"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[2em] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                value={password}
                ref={signPassword}
                onChange = { (e) => {
                  setPassword (e.target.value);
                }}
            />
            <Link to="/password-reset" className="hover:text-gray-700">Forgot Password?</Link>
            {Object.entries(errors).map(([key, error]) => (
        <span
          key={`${key}: ${error}`}
          style={{
            fontWeight: "bold",
            color: "red"
          }}
        >
          {error}
        </span>
        
      ))}
          <a href="https://localhost/">{props.loginStatus}</a>
          <button className="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center text-white bg-blue-700 rounded-[2em] hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900" onClick={login}>Sign In</button>
        </form>
      </div>
      <div className="overlay-container">
        <div className="overlay">
          <div className="overlay-panel overlay-left">
            <h1 className="mb-4 text-4xl font-extrabold leading-none tracking-tight text-white md:text-5xl lg:text-6xl dark:text-white">Welcome Back!</h1>
            <div className="mb-6 text-lg font-normal text-white lg:text-xl sm:px-16 xl:px-48 dark:text-white">Don't forget to login and save your creations.</div>
            <button className="ghost" id="signIn"onClick={signInClick}>Sign In</button>
          </div>
          <div className="overlay-panel overlay-right">
            <h1 className="mb-4 text-4xl font-extrabold leading-none tracking-tight text-white md:text-5xl lg:text-6xl dark:text-white">Hello, Friend!</h1>
            <div className="mb-6 text-lg font-normal text-white lg:text-xl sm:px-16 xl:px-48 dark:text-white">Join us and start saving your names.</div>
            <button className="ghost" id="signUp" onClick={signUpClick}>Sign Up</button>
          </div>
        </div>
      </div>
    </div>
 );
}
export default Login;